function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.773 5.924a.75.75 0 00-.212.424l-.672 4.702-5.48 5.48a.75.75 0 001.06 1.061l5.48-5.48 4.703-.672a.75.75 0 00.424-.212l4.596-4.596a.75.75 0 00-.462-1.277l-3.267-.297-.297-3.267a.75.75 0 00-1.277-.462l-4.596 4.596zm4.42 4.066l-3.713.53.53-3.712 3.287-3.287.209 2.294a.75.75 0 00.68.679l2.293.209-3.287 3.287z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.852 3.541a1 1 0 01-1.195.755 12.043 12.043 0 00-1.552-.245c-3.43-.316-6.966.84-9.59 3.464-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0a11.973 11.973 0 003.464-9.59c-.048-.521-.13-1.04-.245-1.551a1 1 0 111.95-.441A13.973 13.973 0 0125.9 25.9a14.058 14.058 0 01-2.235 1.819l.764 1.91a1 1 0 01-1.857.742l-.669-1.672a14.041 14.041 0 01-11.805 0l-.669 1.672a1 1 0 11-1.857-.742l.764-1.91a14.06 14.06 0 01-2.235-1.82C.634 20.433.634 11.569 6.1 6.102A13.973 13.973 0 0117.29 2.059c.607.056 1.211.151 1.808.286a1 1 0 01.755 1.196z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.292 10.758a.75.75 0 00.083-1.498 6.728 6.728 0 00-5.148 1.967 6.75 6.75 0 1011.512 4.398.75.75 0 10-1.497.083 5.227 5.227 0 01-1.53 4.005 5.25 5.25 0 11-3.42-8.955z",
  fill: "currentColor"
})));